import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button, buttonVariants } from '@/components/ui/button'
import type { VariantProps } from 'class-variance-authority'
import { PropsWithChildren, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends VariantProps<typeof buttonVariants> {
  open: boolean
  descriptionKey?: string
  description?: string
  continueText?: string
  title?: string
  loading?: boolean
  onCancel: () => void
  onContinue: () => void | Promise<void>
}

const ConfirmDialog = (props: PropsWithChildren<Props>) => {
  const { t } = useTranslation()
  const [isContinuing, setIsContinuing] = useState(false)
  const loading = props.loading || isContinuing

  const handleContinue = async () => {
    setIsContinuing(true)
    try {
      await props.onContinue()
    } finally {
      setIsContinuing(false)
    }
  }

  return (
    <AlertDialog open={props.open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {props.title ?? t('shared.are-you-sure')}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {props.description ??
              (props.descriptionKey ? t(props.descriptionKey) : '')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={props.onCancel} disabled={loading}>
            {t('shared.cancel')}
          </AlertDialogCancel>
          <Button
            onClick={handleContinue}
            variant={props.variant ?? 'default'}
            loading={loading}
          >
            {props.continueText ?? t('shared.continue')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default ConfirmDialog
